/**
 *
 * ConfirmProfile
 *
 */

import React, { memo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useLocation } from 'react-router-dom';

// styles
import './style.scss';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

/* import {
  flushStateConfirmProfile,
} from './actions'; */

/* import {
  selectConfirmProfileData,
} from './selectors'; */

// layout components
import Preloader from 'components/Preloader';

// antd component
import { Button, message } from 'antd';

// assets
import CustomIcons from 'components/CustomIcons';

// utils
import api, { setAuthorizationHeader } from 'utils/apis/axiosAPI';

function ConfirmProfile({ history, className }) {
  useInjectReducer({ key: 'resetPassword', reducer });
  useInjectSaga({ key: 'resetPassword', saga });

  const location = useLocation();

  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const urlParams = new URLSearchParams(location.search);

  setAuthorizationHeader();

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    // --> main code here
  
    if (urlParams.get('id')) {
      confirmProfileCallback(urlParams.get('id'), urlParams.get('email'));
    }
    // Anything in here is fired on component unmount.
    return () => {
      // Clearing the state after unmounting a component
    };
  }, []);

  const confirmProfileCallback = (id, email = null) => {
    setIsLoadingConfirm(true);
    api.auth
      .confirmProfile({
        token: id,
        email: email,
      })
      .then(result => {
        setIsLoadingConfirm(false);
        setIsConfirmed(true);
      })
      .catch(err => {
        setIsLoadingConfirm(false);
        setIsConfirmed(false);
        message.error(err.message, 5);
      });
  };
  const resendConfirmProfileCallback = () => {
    setIsLoading(true);
    api.auth
      .resendConfirmProfile({
        email: urlParams.get('email') || null,
      })
      .then(result => {
        setIsLoading(false);
        setIsConfirmed(true);
        message.success(result.message, 5);
      })
      .catch(err => {
        setIsLoading(false);
        setIsConfirmed(false);
        console.error({ err }, err?.response?.dara?.errors?.message);
        message.error(`Something went wrong, try re-registering.`, 5);
      });
  };

  // render function
  return (
    <>
      {isLoadingConfirm && <Preloader fullWidth />}
      {!isLoadingConfirm && (
        <>
          <div className="login-page">
            <div className="login-form__column">
              <div className="login-form__header">
                <CustomIcons className="logo-login" type="logo" />
              </div>

              <div className="login-form__container">
                {!!isConfirmed && (
                  <>
                    <h3 style={{color: '#fff'}}>E-mail confirmé !</h3>

                    <p className="description">
                      Toutes nos félicitations! <br />
                      Votre email a été confirmé et votre compte est prêt.
                      Veuillez fermer cette page et revenir à l'application mobile pour
                      connexion.
                    </p>

                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      className="login-submit"
                      onClick={() => {
                        history.push('/login');
                      }}
                    >
                      Login
                    </Button>
                  </>
                )}
                {!isConfirmed && (
                  <>
                    <p className="disclaimer">
                    Le lien n'est plus actif ou quelque chose s'est mal passé
                      pendant le processus de vérification, veuillez réessayer.
                    </p>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      className="login-submit"
                      loading={isLoading}
                      onClick={resendConfirmProfileCallback}
                    >
                      Renvoyer un courriel de confirmation
                    </Button>
                  </>
                )}
              </div>
            </div>

            <svg
              className="waves"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 24 150 28"
              preserveAspectRatio="none"
              shapeRendering="auto"
            >
              <defs>
                <path
                  id="gentle-wave"
                  d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                />
              </defs>
              <g className="parallax">
                <use
                  href="#gentle-wave"
                  x="48"
                  y="0"
                  fill="rgba(255,255,255,0.7"
                />
                <use
                  href="#gentle-wave"
                  x="48"
                  y="3"
                  fill="rgba(255,255,255,0.5)"
                />
                <use
                  href="#gentle-wave"
                  x="48"
                  y="5"
                  fill="rgba(255,255,255,0.3)"
                />
                <use href="#gentle-wave" x="48" y="7" fill="#fff" />
              </g>
            </svg>
          </div>
        </>
      )}
    </>
  );
}

ConfirmProfile.propTypes = {};

const mapStateToProps = createStructuredSelector({});

function mapDispatchToProps(dispatch) {
  return {
    flushState: () => dispatch(flushStateConfirmProfile()),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(ConfirmProfile);
